var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleSso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6697 11.5707C21.6697 10.7703 21.5994 10.0006 21.4687 9.26172H11.0585V13.6283H17.0072C16.751 15.0394 15.9722 16.235 14.8015 17.0354V19.8678H18.3738C20.4639 17.9026 21.6697 15.0086 21.6697 11.5707Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0585 22.6027C14.0429 22.6027 16.545 21.5919 18.3739 19.8678L14.8016 17.0354C13.8118 17.7127 12.5457 18.1129 11.0585 18.1129C8.17964 18.1129 5.74287 16.1272 4.87368 13.459H1.18085V16.3837C2.99963 20.073 6.73768 22.6027 11.0585 22.6027Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87369 13.4585C4.65263 12.7812 4.52702 12.0577 4.52702 11.3137C4.52702 10.5697 4.65263 9.84621 4.87369 9.1689V6.24414H1.18086C0.43225 7.76809 0.00518799 9.49216 0.00518799 11.3137C0.00518799 13.1353 0.43225 14.8594 1.18086 16.3833L4.87369 13.4585Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0585 4.51515C12.6814 4.51515 14.1384 5.08471 15.2839 6.20331L18.4543 2.96554C16.54 1.14398 14.0379 0.0253906 11.0585 0.0253906C6.73768 0.0253906 2.99963 2.55505 1.18085 6.24435L4.87368 9.16912C5.74287 6.50091 8.17964 4.51515 11.0585 4.51515Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSso);
export default __webpack_public_path__ + "static/media/google_sso.317a9377464e760904ffb53d34790af1.svg";
export { ForwardRef as ReactComponent };